import { render, staticRenderFns } from "./Torliste.vue?vue&type=template&id=27701452&"
import script from "./Torliste.vue?vue&type=script&lang=js&"
export * from "./Torliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports